import React, { useState } from "react";
import { Plus, X } from "lucide-react";

export function Pill({ active, onClick, children, testId }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`px-4 py-2 rounded-full text-sm font-bold border-2 transition-colors duration-200 ${
        active ? "bg-sorted-peach border-sorted-peach text-sorted-ink" : "bg-white border-[#FFF3F0] text-sorted-slate hover:border-sorted-blush"}`}>
      {children}
    </button>
  );
}

export function Label({ children, hint }) {
  return (
    <div className="mb-2">
      <label className="text-sm font-bold text-sorted-ink">{children}</label>
      {hint && <p className="text-xs text-sorted-slate">{hint}</p>}
    </div>
  );
}

export const inputCls = "flex-1 min-w-0 bg-white border-2 border-[#FFF3F0] rounded-2xl px-4 py-3 font-medium text-sorted-ink outline-none focus:border-sorted-peach transition-colors";

export function toggleIn(arr, v) {
  return arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v];
}

export function PillGroup({ options, value, onChange, testPrefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <Pill key={o} active={value.includes(o)} onClick={() => onChange(toggleIn(value, o))} testId={`${testPrefix}-${o.replace(/\s+/g, "-")}`}>{o}</Pill>
      ))}
    </div>
  );
}

export function TagInput({ value, onChange, placeholder, testId, color = "bg-sorted-blush" }) {
  const [text, setText] = useState("");
  const add = () => {
    const v = text.trim();
    if (!v) return;
    if (!value.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...value, v]);
    setText("");
  };
  return (
    <div>
      <div className="flex items-center gap-2">
        <input data-testid={testId} value={text} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} placeholder={placeholder} className={inputCls} />
        <button type="button" onClick={add} data-testid={`${testId}-add`} aria-label="Add"
          className="w-11 h-11 rounded-full bg-sorted-peach text-sorted-ink flex items-center justify-center shrink-0"><Plus size={20} strokeWidth={2.5} /></button>
      </div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {value.map((it, i) => (
            <span key={it} className={`${color} text-sorted-ink text-sm font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5`} data-testid={`${testId}-tag-${i}`}>
              {it}
              <button type="button" onClick={() => onChange(value.filter((_, x) => x !== i))} aria-label={`Remove ${it}`}><X size={13} strokeWidth={3} /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
